import React from 'react';
import { cn } from '../../lib/utils'; // Assuming standard utils, but I'll implement inline if needed or check if it exists. I'll stick to inline classes to be safe or create a simple wrapper.
interface SectionProps {
  id?: string;
  className?: string;
  children: React.ReactNode;
}
export function Section({
  id,
  className = '',
  children
}: SectionProps) {
  return <section id={id} className={`py-20 md:py-32 relative overflow-hidden ${className}`} data-id="element-647">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-648">
        {children}
      </div>
    </section>;
}